import { Link } from "react-router-dom";
import { useAsyncData } from "@/hooks/useAsyncData";
import { listAll, listLeads } from "@/lib/adminRepository";
import { COLLECTION_KEYS, COLLECTIONS } from "@/pages/admin/collections.config";
import { ADMIN } from "@/constants/testIds";
import { Inbox } from "lucide-react";

export default function AdminDashboard() {
  const { data } = useAsyncData(async () => {
    const entries = await Promise.all(
      COLLECTION_KEYS.map(async (k) => [k, (await listAll(COLLECTIONS[k].coll)).length])
    );
    const leads = await listLeads();
    return { counts: Object.fromEntries(entries), leads };
  }, [], { counts: {}, leads: [] });

  const newLeads = (data.leads || []).filter((l) => (l.status || "new") === "new").length;

  return (
    <div data-testid={ADMIN.dashboard}>
      <h1 className="font-serif text-3xl text-ink mb-6">Dashboard</h1>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        <Link to="/admin/leads" className="border border-bronze/30 bg-cream p-6 hover:border-bronze transition-colors">
          <div className="flex items-center gap-3 text-bronze"><Inbox size={20} /><span className="text-[0.65rem] uppercase tracking-wider text-olive">Leads</span></div>
          <div className="font-serif text-4xl text-ink mt-3">{data.leads?.length ?? 0}</div>
          <div className="text-sm text-olive mt-1">{newLeads} new</div>
        </Link>

        {COLLECTION_KEYS.map((k) => (
          <Link key={k} to={`/admin/content/${k}`} className="border border-bronze/20 bg-cream p-6 hover:border-bronze transition-colors">
            <div className="text-[0.65rem] uppercase tracking-wider text-olive">{COLLECTIONS[k].label}</div>
            <div className="font-serif text-4xl text-ink mt-3">{data.counts?.[k] ?? "—"}</div>
            <div className="text-sm text-bronze mt-1">Manage →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
